export const API_PATH = {
    SUPER_ADMIN: {
      LOGIN: "v2/superAdmin/login",
      INSTITUTE_LIST: "v2/superAdmin/getInstitutes",
      INSTITUTE_COUNT: "v2/superAdmin/getInstitutesCount",
      INSTITUTE_SIGNUP: "v2/superAdmin/instituteSignUp",
      EDIT_INSTITUTE_DETAILS: 'v2/superAdmin/editInstituteDetails',
      LEADS: "v2/superAdmin/getLeads",
      UPDATE_LEAD: "v2/superAdmin/editLead",
      CHANGE_LEAD_STATUS: "v2/superAdmin/changeLeadStatus",
      ADD_INSTITUTE_REQUEST: 'v2/superAdmin/instituteRequest',
      REQUEST_LIST: "v2/superAdmin/getRequests",
      EDIT_REQUESTS: "v2/superAdmin/editRequests",
      DELETE_REQUEST: "v2/superAdmin/deleteRequest",
      ACCEPT_REQUEST: 'v2/superAdmin/instituteSignUp',

      ADD_QUESTIONS: 'v2/superAdmin/add-questions',
      UPLOAD_IMAGE: 'v2/superAdmin/add-image',

      ADD_SUBSRIPTIONS: "v2/superAdmin/add-subscriptions",
      
      REQUEST_DELETE_LIST: "v2/superAdmin/getQuestionsIdList",
      DELETE_QUESTIONS: "v2/superAdmin/delete-questions",
      UPDATE_QUESTION: "v2/superAdmin/questions",
      GET_QUESTION_BY_ID: "v2/superAdmin/questions/details",
    },
  };
  